import { useFetch } from '@vueuse/core'
import { proxyRefs } from 'vue'

type AuthResource = {
  uuid: string
  firstname: string
  lastname: string
  email: string
  phone: string
  main_instrument: string | null
  avatar: string | null
  initials: string
  flags: {
    has_password: boolean
    rules_accepted_at: string | null
    updates_accepted_at: string | null
  }
  preferences: {
    autoload_tutorial: boolean
    quickaction_1: string | null
    quickaction_2: string | null
    quickaction_3: string | null
    quickaction_4: string | null
  }
  access: unknown
  connectors: string[]
  schools: unknown
  count_cards: number
}

function useUser() {
  const {
    getApiUrl
  } = useApi()

  const {
    data,
    isFetching: loading,
  } = useFetch(getApiUrl('api/profile'), {
    headers: {
      'Content-Type': 'application/json',
    },
    mode: 'cors',
    credentials: 'include',
  }).get().json<AuthResource>()

  return {
    user: computed(() => data.value),
    loading,
    check: computed(() => !!data.value),
  }
}

export const $auth = proxyRefs(useUser())
